<div class="model-cover terms" *ngIf="showModal">{{loadFocustelements()}}
  <div class="model-box" (keydown)="handleKeydown($event)">
    <div class="modal-header">
      <h2>OOPS!!!</h2>
      <div class="corner-button">
        <button class="close" aria-label="Close" (click)="btnAction()">x</button>
      </div>
    </div>

    <div class="modal-body" [innerHTML]="content">
    </div>
    <div class="text-right modal-footer">
      <div class="btn-group">
        <a href="javascript:void(0)" class="btn btn-secondary btn-click" (click)="btnAction()">Ok</a>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</div>
